import { Sources } from "../utils/enum";
import useCountryConfigHook from "./useCountryConfigHook";

const liveSourcesOrder = [
  Sources.WEBSITE,
  Sources.POS,
  Sources.QR,
  Sources.KIOSK,
  Sources.THUISBEZORGD_NL,
  Sources.UBER_EATS,
  Sources.HOMIE,
];

const baseFinancialSources = [
  {
    key: "ALL",
    value: [Sources.FINANCIAL_ALL],
    translationKey: "all",
  },
  {
    key: "OWN_CHANNEL_ALL",
    value: [Sources.FINANCIAL_OWN_CHANNEL_ALL],
    translationKey: "ownChannel",
  },
  {
    key: "APP_ALL",
    value: [Sources.FINANCIAL_APP_ALL],
    translationKey: "appAll",
  },
  {
    key: "WEBSITE_AND_APP",
    value: [Sources.FINANCIAL_WEBSITE_AND_APP],
    translationKey: "websiteAndApp",
  },
];

const useSourceHook = () => {
  const { sources } = useCountryConfigHook();

  const liveSources = liveSourcesOrder
    .map((source) => sources.find((s) => s.liveSourceValue?.includes(source)))
    .filter(Boolean)
    .map((source) => ({ ...source, value: source.liveSourceValue }));

  const heatMapSources = sources.filter((source) => source.heatmapSourceValue);
  const financialSources = sources
    .filter((source) => source.financialSourceValue)
    .map((source) => source.financialSourceValue);

  const getSource = (source: number) => {
    return sources.find((p) => p.value.includes(source));
  };

  return {
    sources,
    liveSources,
    heatMapSources,
    financialSources: [...baseFinancialSources, ...financialSources],
    getSource,
  };
};

export default useSourceHook;
